import React from 'react';
import PropTypes from 'prop-types';

import { Wrap, Title, Content, Icon } from './styles';

const PageSection = ({ title, children, showTakeMeTo }) => {
  return (
    <Wrap>
      <Title>
        <h3>{title}</h3>
        {showTakeMeTo && (
          <button type="button">
            <Icon />
            Take me to...
          </button>
        )}
      </Title>
      <Content>{children}</Content>
    </Wrap>
  );
};

PageSection.defaultProps = {
  showTakeMeTo: true,
};

PageSection.propTypes = {
  title: PropTypes.string.isRequired,
  showTakeMeTo: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default PageSection;
